module.exports = __webpack_public_path__ + "img/selected6-min.c213a4f1.png";